<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('ModifiedSchiffPitchforkTool', function() {
            return {
                group: 'Lines', category: 'Pitchforks', icon: 'pitchfork.svg',
                type: 'ModifiedSchiffPitchfork',
                name: 'Modified Schiff Pitchfork',
                hint: "Modified Schiff's Pitchfork",
                data: [],
                settings: {}
            }
        }, 'Modified Schiff Pitchfork')
</script>
